import * as Yup from "yup";
import { validationMessages } from "../constants/validation";

const requiredMsg = validationMessages.required;

export const YupAdresseGeneric = (
  schema: Yup.ObjectSchema<object, Yup.AnyObject, object, "">,
) =>
  schema.shape({
    adresselinie1: Yup.string().required(requiredMsg),
    adresselinie2: Yup.string().nullable(),
    postnummer: Yup.string().required(requiredMsg),
    bynavn: Yup.string().required(requiredMsg),
    adresselinie4: Yup.string().nullable(),
    landekode: Yup.string().required(requiredMsg),
  });

export const YupAdresseGenericNoLandekode = (
  schema: Yup.ObjectSchema<object, Yup.AnyObject, object, "">,
) =>
  schema.shape({
    adresselinie1: Yup.string().required(requiredMsg),
    adresselinie2: Yup.string(),
    postnummer: Yup.string().required(requiredMsg),
    bynavn: Yup.string().required(requiredMsg),
    adresselinie4: Yup.string(),
  });

/**
 * Lektionstal må have decimaler — et kursusbevis eller en kendelse kan lyde på fx
 * 12,34 lektioner. Der er bevidst ingen decimalgrænse her: serveren afrunder til to
 * decimaler, og inputfelterne bruger step="any", så browseren ikke afviser tallet,
 * før det når frem. Se cle-compliance-api round_lessons og .NET LessonMath.Round.
 */
export const YupNumberOfLessonsNullable = () =>
  Yup.number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .nullable()
    .typeError("Antal lektioner skal være et tal");

export const YupNumberOfLessonsRequired = () =>
  Yup.number()
    .transform((value, originalValue) =>
      originalValue === "" ? undefined : value,
    )
    .typeError("Antal lektioner skal være et tal")
    .required("Antal lektioner skal udfyldes")
    .positive("Antal lektioner skal være større end 0");
